import { render, staticRenderFns } from "./VxCellList.vue?vue&type=template&id=3670cc0e&"
import script from "./VxCellList.vue?vue&type=script&lang=js&"
export * from "./VxCellList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports